import { Box } from "@mui/material"

import Iconify from "minimals-template/components/Iconify"
import AppWelcome from "minimals-template/pages/sections/@dashboard/general/app/AppWelcome"
import { useEffect } from "react"
import { logUiEvent } from "routes/log/controller/log-event"

export function TieredAccessGate({ title, bodyText, logEvent }) {
    useEffect(() => {
        logUiEvent("tiered-access-attempt", { tab: logEvent })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box flexGrow={1} mb={3} p={2} data-cy="tiered-access-gate">
            <AppWelcome
                title={title}
                img={
                    <Box position="relative" overflow="hidden" flexGrow={1} width={150} height={160}>
                        <Box position="absolute" right={20} zIndex={200} opacity={0.5}>
                            <Iconify
                                sx={{
                                    width: 90,
                                    height: 90,
                                    opacity: 0.3,
                                    mr: 3,
                                    transform: "scale(1.7) translateY(19px)",
                                    color: "primary.dark",
                                }}
                                icon="streamline:padlock-square-1-solid"
                            />
                        </Box>
                    </Box>
                }
                description={
                    <>
                        {bodyText.map((text, index) => (
                            <Box key={index} mt={index > 0 ? 1 : 0}>
                                {text}
                            </Box>
                        ))}
                    </>
                }
            />
        </Box>
    )
}
